import { LogLevel } from '@azure/msal-browser';

const isLocal = window.location.origin.includes("localhost");

export const msalConfig = {
    auth: {
        clientId: '4bf4bdb7-5a07-4ff0-9e52-588f0f86a6a3',
        authority: 'https://login.microsoftonline.com/56d6d072-5079-4853-80ca-e08cdea8ff6e',
        redirectUri: isLocal ? 'http://localhost:3000/admin-dashboard' : 'https://hrapp.aqili.ai/admin-dashboard'
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        break;
                    case LogLevel.Info:
                        console.info(message);
                        break;
                    case LogLevel.Verbose:
                        console.debug(message);
                        break;
                    case LogLevel.Warning:
                        console.warn(message);
                        break;
                    default:
                        console.log("Unknown LogLevel:", message);
                        break;
                }
            }
        }
    }
};

export const loginRequest = {
    scopes: ["User.Read"]
};
